/**
 * BrandLogo — the intranet "i" mark: a lowercase i whose tittle is the accent
 * dot. Geometry mirrors `public/favicon.svg` (brand guidelines v1.0). The stem
 * follows `currentColor` so it flips with the theme; only the dot carries the
 * accent, per the guidelines (never recolor the stem).
 */

interface BrandLogoProps {
  /** Rendered height in px; width follows the glyph's 1:3 aspect. */
  height?: number;
  className?: string;
}

export function BrandLogo({ height = 28, className = '' }: BrandLogoProps) {
  return (
    <svg
      role="img"
      aria-label="intranet"
      viewBox="36 6 28 84"
      height={height}
      width={(height * 28) / 84}
      className={'shrink-0 text-ink ' + className}
    >
      <circle cx="50" cy="20" r="11.5" className="fill-accent" />
      <rect x="38.5" y="39" width="23" height="49" rx="11.5" fill="currentColor" />
    </svg>
  );
}
